/*
 * @Description:
 * @Author: -898-
 * @Date: 2024-04-23 09:02:35
 * @LastEditTime: 2025-03-10 15:13:02
 * @LastEditors: -898-
 */

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Cookies from "js-cookie";
import { getToken } from "@/utils/auth";

Vue.config.productionTip = false;

document.addEventListener("click", (e) => {
  const fileLink = e.target.closest(".file-link");
  if (fileLink) {
    e.preventDefault();
    const url = fileLink.getAttribute("data-url");
    if (!url) return;
    if (getToken()) {
      window.open(url, "_blank");
    } else {
      Vue.prototype.$message.warning("请先登录");
    }
  }
});

//引入全局样式
import "@/assets/styles/index.scss";

//引入element-ui
// import '@/plugin/element-ui';
import "element-ui/lib/theme-chalk/index.css";
import Element from "element-ui";
import "animate.css";
// 分页组件
import Pagination from "@/components/Pagination";
// 公共标题
import CommonTitle from "@/components/Common/CommonTitle";
// 字典标签组件
import DictTag from "@/components/DictTag";
// 字典数据组件
import DictData from "@/components/DictData";

import { getDicts } from "@/api/system/dict/data";

// 预览
import CtPreview from "@/components/CtPreview/index.js";

// 全局组件挂载
Vue.component("DictTag", DictTag);
Vue.component("Pagination", Pagination);
Vue.component("CommonTitle", CommonTitle);

import { download } from "@/utils/request";
Vue.prototype.download = download;
Vue.prototype.getDicts = getDicts;
Vue.prototype.$Preview = CtPreview;
// import Cookies from "js-cookie";

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
// Vue.use(Element, {
//   size: Cookies.get("size") || "medium", // set element-ui default size
//   // locale: enLang, // 如果使用中文，无需设置，请删除
// });
Vue.use(Element);
DictData.install();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
